


































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { Conto } from '@/data/models/conto.model';
import { ContoService } from '@/data/services/conto.service';

@Component
export default class ContoList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop() type!: string;
	
	@Inject('ContoService') contoService!: ContoService;

	rows: Conto[] = [];
	loading: boolean = false;

	constructor() {
		super();
	}

	loadConti() {
		this.loading = true;
		this.contoService.search(this.type, '')
			.then((results) => {
				this.rows = results;
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editConto(item: Conto) {
		this.$emit('edit', item);
	}

	deleteConto(item: Conto) {
		this.$emit('delete', item);
	}

}
